import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import dayjs, { Dayjs } from "utils/dayjs"
import { Guid, IApiLink } from "@/types"
import { getFileNameAndExtension } from "utils/utils"

export interface IGetDocumentDto {
    id: Guid
    name: string
    uri: string
    attachedAutomatically?: boolean | null
    uploadDate: string
    uploadedBy: Guid
    links: IApiLink[]
}

export interface IUpdateDocumentDTO {
    documentCategoryId: Guid
}

export class Document {
    id: Guid
    name: string
    uri: string
    attachedAutomatically: boolean
    uploadDate: Dayjs
    uploadedByEmail?: string
    linkUpdateDocument?: IApiLink
    linkDeleteDocument?: IApiLink

    constructor(dto: IGetDocumentDto, { entity, uploadedByEmail }: { entity: ApiLinkEntity, uploadedByEmail?: string }) {
        this.id = dto.id
        this.name = dto.name
        this.uri = dto.uri
        this.attachedAutomatically = dto.attachedAutomatically || false
        this.uploadDate = dayjs(dto.uploadDate)
        this.uploadedByEmail = uploadedByEmail
        this.linkUpdateDocument = dto.links.find(lnk => lnk.entity === entity && lnk.rel === ApiLinkRel.partialUpdate)
        this.linkDeleteDocument = dto.links.find(lnk => lnk.entity === entity && lnk.rel === ApiLinkRel.delete)

    }

    getNameAndExtension() {
        return getFileNameAndExtension(this.name)
    }
}
